import CallApp from '@/config/callApp.js'
import {pageConfig} from '@/config/clientPageConfig.js'
import {hideMenuItems,shareFriend,shareFriendQ} from '@/utils/weixin.js'

export function currentUrlToParams(key = null) {
    let paramsUrl = (window.location.href).split('?');

    if(paramsUrl.length<2)return key ? null : {};
    let paramsArr = paramsUrl[1].split('&');
    let paramsData = {}

    paramsArr.forEach(r=>{
        let data = r.split('=')
        paramsData[data[0]] = data[1]
    })
    if(key)return paramsData.hasOwnProperty(key) ? paramsData[key] : null;
    return paramsData;

}


export function obj2StrParams(obj,firstStr = '?') {
    let params = firstStr;
    for (let p in obj){
        let isFirst = ( params === '?');
        let qz = isFirst ? '' : (params === '&' ? '' : '&');
        params += (qz + p + '=' + obj[p] )
    }
    return params
}


/**
 * 重置对象参数
 * @params -> Object
 * @arg = Array => []
 * @arg = Boolean => false
 * @arg = Number => null
 * @arg = String => ''
 * */
export function resetArgs(args,def = {}) {
    for (let key in args) {
        if(def.hasOwnProperty(key)){
            args[key] = def[key]
        }else {
            if (Array.isArray(args[key])) args[key] = [];
            if ('string' == typeof args[key]) args[key] = '';
            if ('number' == typeof args[key]) args[key] = null;
            if ('boolean' == typeof args[key]) args[key] = false;
        }
    }
}

/**
 * @param obj
 * @param row
 */
export function fillerLeft(obj,row = {}) {
    for (let key in obj) {
        if(row.hasOwnProperty(key) && row[key] !== null && row[key] !== undefined){
            obj[key] = row[key]
        }
    }
}

/**
 * oss 根据宽高裁剪图片
 图片剪切样式：
 x-oss-process=image/resize,m_mfit,w_200,h_100
 参数：
 w_宽度
 h_高度

 示例：
 https://p.hulian120.com/article/cover/355c15139c374d489e42bbdc4c5a761f.png?x-oss-process=image/resize,m_mfit,w_100,h_100
 */
export function cropPicture(path, w, h) {
    if (!path) return path;
    let separator = path.includes('?') ? '&' : '?';
    let afterUrl = `x-oss-process=image/resize,m_mfit,w_${w}`;
    if (h) {
        afterUrl = `x-oss-process=image/resize,m_mfit,w_${w},h_${h}`;
    }
    return path + separator + afterUrl;
}


/**
 * downloadApp
 */
export function downloadApp() {
    window.location.href = CallApp.fallback
}


export function switchZhDate(date) {
    let rege = /["年", "月", "日"]/gi;
    return date.split(rege).slice(0, 3).join('-')
}

/**
 * 微信分享配置
 * title 标题
 * desc 描述
 * fn 回调方法
 */

export function wechatShareConfig(config, fn) {
    pageConfig.wechatConfig.shareTitle = config.shareTitle || '';
    pageConfig.wechatConfig.shareDesc = config.shareDesc || '';
    pageConfig.wechatConfig.shareUrl = config.shareUrl || window.location.href;
    config.shareImg ? pageConfig.wechatConfig.shareImg = config.shareImg : ''


    shareFriend(pageConfig.wechatConfig, fn);
    shareFriendQ(pageConfig.wechatConfig, fn);
}

export function hideWechatMenuItems(config = []) {
    if (Array.isArray(config) && config.length === 0) {
        config = [
            'menuItem:readMode', // 阅读模式
            'menuItem:share:timeline', // 分享到朋友圈
            'menuItem:share:weiboApp', // 分享到微博
            'menuItem:share:qq', // 分享到qq
            'menuItem:copyUrl', // 复制链接
            'menuItem:openWithQQBrowser', // 在QQ浏览器中打开
            'menuItem:openWithSafari', // 在Safari中打开
        ];
    }
    hideMenuItems(config);
}

/**
 * 清空浏览器缓存
 * window.performance.navigation.type
 * 页面通过历史记录和前进后退访问时 type值为2
 * 当前页面是通过点击链接，书签和表单提交，或者脚本操作，或者在url中直接输入地址，type值为0
 */
export function clearDiskCache() {
    window.addEventListener(
      "pageshow",
      e => {
        if (
          e.persisted ||
          (window.performance && window.performance.navigation.type == 2)
        ) {
          location.reload();
        }
      },
      false
    );
  }
  /*
获取当前url
http://192.168.49.71:8081/ => http://192.168.49.71:8081/
http://192.168.49.71:8081/mm/ => http://192.168.49.71:8081/mm/
http://192.168.49.71:8081/mm/index.html => http://192.168.49.71:8081/mm/
http://192.168.49.71:8081/mm/ff/login.html?id=55 => http://192.168.49.71:8081/mm/ff/

页面名字不能能匹配除\w 的地址，也就是说你的页面名字名字必须由a-z、A-Z、0-9，以及下划线组成才可以。
*/
export function getCurrentUrl() {
  let allUrl = window.location.href;
  let match = allUrl.match(/(\S+\/)\w+.html/i);
  return match && Array.isArray(match) && match.length > 1
    ? match[1]
    : allUrl.indexOf("?") === -1
    ? allUrl
    : allUrl.split("?")[0];
}
export function delCurrentUrlParam(key) {
    let url = window.location.href;
    let urlObj = new URL(url);
    urlObj.searchParams.delete(key);
    return urlObj.href;
}